<template>
  <div id="specialFileDetailPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="پرونده تخصصی"></ActionBar>
    <div v-if="isContentLoaded" class="row container mx-auto p-0  mt-2">
      <div  class="col-12 mx-auto p-0">
        <div class="card-shadow round10px bg-white p-2 my-2 card-top-line">
          <div class="font12px "><span
              class="py-1 px-3 rounded-xl primary-background white--text"> {{ filename }}</span>
          </div>
          <div class="mt-3 font-weight-bold"><img :src="getImgUrl('file-report.png')" alt="پرونده"
                                                  class="img-fluid pl-1">
          </div>
          <div v-if="isPdfLoaded" class="col-12 px-0 ">
            <vue-pdf-app :config="config" :pdf="file" style="height: 100vh"></vue-pdf-app>
          </div>
        </div>
      </div>
    </div>
    <v-fab-transition>
      <v-btn
          id="memberShipFabBtn"
          color="forth"
          dark
          fab
          fixed
          left
          @click="$openLink(file)">
        <i class="fas fa-eye font20px pl-1"></i>
      </v-btn>
    </v-fab-transition>
    <FooterMenu/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";



export default {
  name: "SpecialFileDetail",
  metaInfo: {
    title: 'مسیربرتر-پرونده تخصصی'
  },
  components: {FooterMenu, ActionBar,VuePdfApp},
  data: () => ({
    items: [],
    isContentLoaded: false,
    isPdfLoaded: false,
    showLoaderDialog: false,
    filename:null,
    file:null,
    config: {
      secondaryToolbar: false,
      toolbar: {
        toolbarViewerLeft: {findbar: false},
        toolbarViewerRight: false,
        toolbarViewerMiddle: {
          scaleSelectContainer: false
        }
      }

    },
  }),
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.showLoaderDialog = true
      this.filename = this.$route.query.Name
      this.file = this.$replaceHttps(this.$route.query.FileUrl)
      this.isContentLoaded=true
      this.isPdfLoaded=true
      this.showLoaderDialog=false

    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    downloadFile(link){
     this.$openLink(link)
    }
  }
}
</script>
